import React, { createContext, useState } from "react";

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toastMessages, setToastMessages] = useState([]);

  const addToast = (message = {}, type = "info", duration = 5000) => {
    type = type === "error" ? "danger" : type;
    setToastMessages((prev) => [
      ...prev,
      { ...message, variant: type, delay: duration },
    ]);
    //  Auto-remove after duration
    setTimeout(() => message.id && removeToast(message.id), duration);
  };

  const removeToast = (id) => {
    setToastMessages((prev) => prev.filter((toast) => toast.id !== id));
  };

  const value = {
    toastMessages,
    addToast,
    removeToast,
  };

  return (
    <ToastContext.Provider value={value}>{children}</ToastContext.Provider>
  );
};
